import { render, staticRenderFns } from "./annotationsLayer.vue?vue&type=template&id=0c4d2afd&scoped=true&"
import script from "./annotationsLayer.vue?vue&type=script&lang=js&"
export * from "./annotationsLayer.vue?vue&type=script&lang=js&"
import style0 from "./annotationsLayer.vue?vue&type=style&index=0&id=0c4d2afd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d2afd",
  null
  
)

export default component.exports